import create from "zustand";

interface ModalState {
  listTalhoesLogicos: string[];
  talhaoLogico: any;
  listTalhoesLogicosImport: any[];
  listTalhoesPlanejadosImport: any[];
  geoJSON: any;
  isCopyWithImport: boolean
  hasData: boolean
  copyWithImportObject: any[]
  
  setListTalhoesLogicos: (args: string[]) => void;
  setTalhaoLogico: (args: string[]) => void;
  setListTalhaoLogicoImport: (args: any) => void;
  setListTalhaoPlanejadosImport: (args: any) => void;
  setGeoJSON: (args: any) => void;
  setIsCopyWithImport: (args: boolean) => void;
  setHasData: (args: boolean) => void;
  setCopyWithImportObject: (args: any) => void;
  
}

const useModalSelecaoTalhoes = create<ModalState>((set) => ({
  listTalhoesLogicos: [],
  talhaoLogico: null,
  listTalhoesLogicosImport: [],
  listTalhoesPlanejadosImport: [],
  geoJSON: null,
  isCopyWithImport: false,
  hasData: false,
  copyWithImportObject: [],

  setListTalhoesLogicos: (listTalhoesLogicos) => {
    set(state => ({ listTalhoesLogicos }));
  },

  setTalhaoLogico: (talhaoLogico) => {
    set(state => ({ talhaoLogico }));
  },
 
  setListTalhaoLogicoImport: (listTalhoesLogicosImport) => {
    set(state => ({ listTalhoesLogicosImport }));
  },

  setListTalhaoPlanejadosImport: (listTalhoesPlanejadosImport) => {
    set(state => ({ listTalhoesPlanejadosImport }));
  },

  setGeoJSON: (geoJSON) => {
    set(state => ({ geoJSON }));
  },

  setIsCopyWithImport: (isCopyWithImport) => {
    set(state => ({ isCopyWithImport }));
  },

  setHasData: (hasData) => {
    set(state => ({ hasData }));
  },

  setCopyWithImportObject: (copyWithImportObject) => {
    set(state => ({ copyWithImportObject }));
  },
  
}));

export default useModalSelecaoTalhoes;
